export const pascalCase = (word: string) => word.toLowerCase().charAt(0).toUpperCase() + word.toLowerCase().substr(1);